<template>
  <el-dialog
    title="选择会员"
    width="400px"
    :visible.sync="dialogUpdloadWechatFile.isShow"
    append-to-body
    @opened='Opened'
  >  
    <el-form @submit.native.prevent>      
      <el-form-item >
        <el-col :span="18">
          <el-upload
            class="upload-demo"
            drag
            :action="uploadUrl"
            :headers="headers"
            :on-success="handleIconSuccess"
            multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload>
        </el-col>
        <el-col :span="7">
          <el-button type="primary" v-on:click="Save" >确定</el-button>
        </el-col>
      </el-form-item>
    </el-form>  

  </el-dialog>
</template>
<script  type='text/ecmascript-6'>
   import { Loading } from 'element-ui';
   export default {
    props:{
      dialogUpdloadWechatFile:{        
      }
    },
    data(){
      return {
        number:'',
        loading:false,
        form:{},
        uploadUrl: this.global.serverSrc+'/api/Common/UpdloadWechatPayMedial',
        headers:{
          Authorization : sessionStorage.getItem('token')
        },
        mediaId:''
      }
    },
    mounted(){
      
    },
    methods:{
      Opened:function(){        
      },
      Search:function(){
        this.GetData();
      }, 
      handleIconSuccess(res, file){
        if(res.errorCode==0){
          this.mediaId= res.fullUrl
        }else{          
          this.$message.warning(res.message);
        }
      },
      Save:function(){        
        this.$emit('UpdateUpdloadWechatFile',this.mediaId)
      }
    }
   }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.el-button--primary
  margin-left 5px
</style>

